import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-table-no-data',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span *ngIf="searchValue">Nenhum registro encontrado para a pesquisa: "{{ searchValue }}"</span>
    <span *ngIf="!searchValue">Nenhum registro disponível</span>
  `
})
export class TableNoDataComponent {
  @Input() searchValue: string | undefined = ''
}
